const PLUGIN_NAME = 'sc-content';

export { PLUGIN_NAME };
